import React, {useEffect} from "react";
import {
    Box,
    Grid,
    Typography,
    Avatar,
    Divider,
    Skeleton,
    useTheme,
    useMediaQuery,
} from "@mui/material";
import Chip from "@mui/material/Chip";
import imageAvatar from "../../../../assets/Tenant_avatar.jpg";
import {LocationOn} from "@material-ui/icons";
import {ResponsiveContainer} from "recharts";
import {styled} from "@mui/system";

// Responsive container for property card
const PropertyCardContainer = styled(Box)(({ theme }) => ({
    margin: "20px",
    marginTop: "20px",
    padding: "20px",
    borderRadius: "8px",
    border: "1px solid #E0E0E0",
    backgroundColor: "#F9FAFB",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.05)",
    [theme.breakpoints.down('md')]: {
        margin: "12px",
        marginTop: "12px",
        padding: "16px",
    },
    [theme.breakpoints.down('sm')]: {
        margin: "8px",
        marginTop: "8px",
        padding: "12px",
        borderRadius: "6px",
    }
}));

const LeftSide = (props) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const {propertyDetails, propertyImage} = props;

    useEffect(() => {
        console.log("propertyDetails");
        console.log(propertyDetails);
    }, [propertyDetails])


    const LoadingSkeleton = () => {
        return (
            <ResponsiveContainer>
                {/* Header skeleton */}
                <Box sx={{display: "flex", flexDirection: "column", alignItems: "center", marginBottom: "20px"}}>
                    <Skeleton variant="circular" width={80} height={80} sx={{marginBottom: "10px"}}/>
                    <Skeleton variant="text" width="80%" height={28} sx={{marginBottom: "5px"}}/>
                    <Skeleton variant="text" width="60%" height={20}/>
                </Box>

                <Divider sx={{marginY: "10px"}}/>

                {/* Details sections skeleton */}a
                {[1, 2, 3, 4].map((section) => (
                    <Box key={section} sx={{marginBottom: "20px"}}>
                        <Skeleton variant="text" width="70%" height={24} sx={{marginBottom: "10px"}}/>
                        {[1, 2, 3].map((item) => (
                            <Box key={item}
                                 sx={{display: "flex", justifyContent: "space-between", marginBottom: "8px"}}>
                                <Skeleton variant="text" width="45%" height={16}/>
                                <Skeleton variant="text" width="35%" height={16}/>
                            </Box>
                        ))}
                        {section < 4 && <Divider sx={{marginY: "10px", backgroundColor: "#E0E0E0"}}/>}
                    </Box>
                ))}
            </ResponsiveContainer>
        );
    };


    if (propertyDetails.landlord_id === "") {
        return (
            <PropertyCardContainer>
                <LoadingSkeleton/>
            </PropertyCardContainer>
        )
    }

    return (
        <PropertyCardContainer>
            {/* Customer Header */}
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    marginBottom: isMobile ? "16px" : "20px",
                }}
            >
                <Avatar
                    sx={{
                        width: isMobile ? 70 : 80,
                        height: isMobile ? 70 : 80,
                        backgroundColor: "#E0E0E0",
                        marginBottom: "10px",
                    }}
                    src={propertyImage === "" ? imageAvatar : propertyImage}
                />

                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: "bold",
                        color: "#2C5283",
                        textAlign: "center",
                        fontSize: isMobile ? '1.1rem' : '1.25rem',
                    }}
                >
                    {propertyDetails.property_name.toUpperCase()}
                </Typography>
                {propertyDetails.location && (
                    <Box sx={{display: "flex", alignItems: "center", gap: "5px", textAlign: "center"}}>
                        <LocationOn fontSize="small" sx={{color: "#2C5283"}}/>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{ fontSize: isMobile ? '0.8rem' : '0.875rem' }}
                        >
                            {propertyDetails.location}
                        </Typography>
                    </Box>
                )}
            </Box>

            <Divider sx={{marginY: "10px", backgroundColor: "#2C5283"}}/>

            {/* Details Section */}
            <Box sx={{marginBottom: "20px"}}>
                <Typography variant="subtitle1" sx={{fontWeight: "bold", marginBottom: "10px"}}>
                    Property Details
                </Typography>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <Typography variant="body2" sx={{color: "#4A5568"}}>
                            Total Units:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{textAlign: "right"}}>
                        <Typography variant="body2" sx={{fontWeight: "bold"}}>
                            {propertyDetails.total_property_units}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body2" sx={{color: "#4A5568"}}>
                            Vacant Units:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{textAlign: "right"}}>
                        <Typography variant="body2" sx={{fontWeight: "bold"}}>
                            {Math.floor(((100.0 - parseFloat(propertyDetails.occupancy)) / 100) * 7)}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant="body2" sx={{color: "#4A5568"}}>
                            Occupancy:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{textAlign: "right"}}>
                        <Typography variant="body2" sx={{fontWeight: "bold"}}>
                            {propertyDetails.occupancy}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>

            <Divider sx={{marginY: "10px", backgroundColor: "#2C5283"}}/>

            <Box sx={{marginBottom: "20px"}}>
                <Typography variant="subtitle1" sx={{fontWeight: "bold", marginBottom: "10px"}}>
                    Contact Information
                </Typography>
                <Grid container spacing={1}>
                    {propertyDetails.query_number && <><Grid item xs={6}>
                        <Typography variant="body2" sx={{color: "#4A5568"}}>
                            Query No.:
                        </Typography>
                    </Grid>
                        <Grid item xs={6} sx={{textAlign: "right"}}>
                            <Typography variant="body2" sx={{fontWeight: "bold"}}>
                                {propertyDetails.query_number}
                            </Typography>
                        </Grid></>
                    }

                </Grid>
            </Box>


            <Divider sx={{backgroundColor: "#2C5283"}}/>

            <Box sx={{marginBottom: "20px"}}>
                <Typography variant="subtitle1" sx={{fontWeight: "bold", marginBottom: "10px"}}>
                    Billing Information
                </Typography>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <Typography variant="body2" sx={{color: "#4A5568"}}>
                            Water Cost/Unit:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{textAlign: "right"}}>
                        <Typography variant="body2" sx={{fontWeight: "bold"}}>
                            {parseInt(
                                propertyDetails.water_bill.toString().replace(",", "")
                            ).toLocaleString("en-US", {
                                style: "currency",
                                currency: "KSH",
                            })}
                        </Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="body2" sx={{color: "#4A5568"}}>
                            Minimum water Cost/Unit:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{textAlign: "right"}}>
                        <Typography variant="body2" sx={{fontWeight: "bold"}}>
                            {parseInt(
                                propertyDetails.minimum_water_bill.toString().replace(",", "")
                            ).toLocaleString("en-US", {
                                style: "currency",
                                currency: "KSH",
                            })}
                        </Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="body2" sx={{color: "#4A5568"}}>
                            Electricity Cost/Unit:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{textAlign: "right"}}>
                        <Typography variant="body2" sx={{fontWeight: "bold"}}>
                            {parseInt(
                                propertyDetails.electricity_bill.toString().replace(",", "")
                            ).toLocaleString("en-US", {
                                style: "currency",
                                currency: "KSH",
                            })}
                        </Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="body2" sx={{color: "#4A5568"}}>
                            Minimum Electricity Cost/Unit:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{textAlign: "right"}}>
                        <Typography variant="body2" sx={{fontWeight: "bold"}}>
                            {parseInt(
                                propertyDetails.minimum_electricity_bill.toString().replace(",", "")
                            ).toLocaleString("en-US", {
                                style: "currency",
                                currency: "KSH",
                            })}
                        </Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="body2" sx={{color: "#4A5568"}}>
                            Other charges:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{textAlign: "right"}}>
                        <Typography variant="body2" sx={{fontWeight: "bold"}}>
                            {parseInt(
                                propertyDetails.other_charges.toString().replace(",", "")
                            ).toLocaleString("en-US", {
                                style: "currency",
                                currency: "KSH",
                            })}
                        </Typography>
                    </Grid>


                </Grid>
            </Box>

            <Divider sx={{backgroundColor: "#2C5283"}}/>

            <Box sx={{marginBottom: "20px"}}>
                <Typography variant="subtitle1" sx={{fontWeight: "bold", marginBottom: "10px"}}>
                    Other Details
                </Typography>
                <Grid container spacing={1}>
                    <Grid item xs={6}>
                        <Typography variant="body2" sx={{color: "#4A5568"}}>
                            Apply Penalty:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{textAlign: "right"}}>
                        <Chip
                            label={propertyDetails.apply_penalty}
                            color={propertyDetails.apply_penalty === "YES" ? "success" : "error"}
                            variant="outlined"
                            sx={{fontWeight: "bold"}}
                        />
                    </Grid>


                    <Grid item xs={6}>
                        <Typography variant="body2" sx={{color: "#4A5568"}}>
                            Penalty Date:
                        </Typography>
                    </Grid>
                    <Grid item xs={6} sx={{textAlign: "right"}}>
                        <Typography variant="body2" sx={{fontWeight: "bold"}}>
                            {propertyDetails.penalty_date === "" ? 11 : propertyDetails.penalty_date}
                        </Typography>
                    </Grid>


                    <Grid item xs={6}>
                        <Typography variant="body2" sx={{color: "#4A5568"}}>
                            Percentage Penalty:
                        </Typography>
                    </Grid>

                    <Grid item xs={6} sx={{textAlign: "right"}}>
                        <Typography variant="body2" sx={{fontWeight: "bold"}}>
                            {propertyDetails.penalty_percentage === "" ? 10 : propertyDetails.penalty_percentage}
                        </Typography>
                    </Grid>

                    <Grid item xs={6}>
                        <Typography variant="body2" sx={{color: "#4A5568"}}>
                            Reminder Date:
                        </Typography>
                    </Grid>

                    <Grid item xs={6} sx={{textAlign: "right"}}>
                        <Typography variant="body2" sx={{fontWeight: "bold"}}>
                            {propertyDetails.reminder_date === "" ? 5 : propertyDetails.reminder_date}
                        </Typography>
                    </Grid>


                    <Grid item xs={6}>
                        <Typography variant="body2" sx={{color: "#4A5568"}}>
                            Payment Details:
                        </Typography>
                    </Grid>

                    <Grid item xs={6} sx={{textAlign: "right"}}>
                        <Typography variant="body2" sx={{fontWeight: "bold"}}>
                            {propertyDetails.payment_details}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </PropertyCardContainer>);
};

export default LeftSide;